import { STATUS } from "@/constant/statusConstants";

export const ProductInitialValues = (localeCodes, showData) => ({
  code: showData?.data?.code || "",
  product_class_id: showData?.data?.product_class_id || "",
  status: showData?.data?.status || STATUS.INACTIVE,
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
});
